import gql from 'graphql-tag';

const query = gql`
  query SystemOfMeasuresQuery {
    me {
      id
      systemOfMeasures
    }
  }
`;

export default query;
